import { session, appState, EP, THU_IMIE, API_BASE } from '../config.js';
import { fmt } from '../format.js';
import { ICONS, hydrateIcons, svg } from '../icons.js';
import { lineChart } from '../chart.js';
import { DEMO, demoDay } from '../demo.js';
import { apiGet, apiPost, apiPut, noData, imieFor } from '../api.js';
import { C, spinner, emptyRow, toast } from '../ui.js';
import { closeModal } from '../modal.js';
import { go } from '../router.js';
import { applyRole, canDelete } from '../auth.js';

export let usersCache=[];

export async function viewUsers(){
  C().innerHTML=`<div class="panel"><div class="panel-head"><h2>Users Management</h2>
    <button class="btn add" onclick="openUserForm('add')"><span data-icon="plus" data-size="16"></span>Add User</button></div>
    <div class="panel-body" style="padding:0"><table><thead><tr><th>User Name</th><th>Mobile</th><th>Role</th><th>Insert</th><th>Update</th><th>Delete</th><th>Actions</th></tr></thead>
    <tbody id="usersBody"><tr><td colspan="7">${spinner}</td></tr></tbody></table></div></div>`;
  let list=DEMO.users.map(u=>({UserName:u[0],Mobile:u[1],Typed:u[2],DataInsert:u[3],DataUpdate:u[4],DataDelete:u[5]}));
  try{const r=await apiGet('GetApi.php',{ID:session.IMIE,TableName:'Logins'});const d=await r.json();if(!noData(d))list=d}catch(e){appState.OFFLINE=true;applyRole()}
  usersCache=list;
  const yn=v=>(v==1||v==='1'||v===1)?1:0;
  const tb=document.getElementById('usersBody');if(!tb)return;
  tb.innerHTML=list.length? list.map((u,i)=>`<tr>
    <td style="font-weight:600">${u.UserName||''}</td><td class="num">${u.Mobile||''}</td><td><span class="role">${u.Typed||''}</span></td>
    <td><span class="tag ${yn(u.DataInsert)?'yes':'no'}">${yn(u.DataInsert)?'Yes':'No'}</span></td>
    <td><span class="tag ${yn(u.DataUpdate)?'yes':'no'}">${yn(u.DataUpdate)?'Yes':'No'}</span></td>
    <td><span class="tag ${yn(u.DataDelete)?'yes':'no'}">${yn(u.DataDelete)?'Yes':'No'}</span></td>
    <td><div class="row-actions"><button class="mini" onclick="openUserForm('edit',${i})"><span data-icon="edit" data-size="15"></span>Edit</button>
      <button class="mini del" onclick="confirmDeleteUser(${i})"><span data-icon="trash" data-size="15"></span>Delete</button></div></td></tr>`).join('')
    : emptyRow(7,'No users yet');
  hydrateIcons(tb);
}

export function openUserForm(mode,i){
  const u=mode==='edit'?usersCache[i]:{UserName:'',Mobile:'',Typed:'Unofficial',DataInsert:1,DataUpdate:1,DataDelete:0,NoOfDays:30};
  const yn=v=>(v==1||v==='1')?1:0;
  const roleOpts=['Official','Unofficial'].map(r=>`<option ${u.Typed===r?'selected':''}>${r}</option>`).join('');
  document.getElementById('modalRoot').innerHTML=`
   <div class="modal-overlay" onclick="if(event.target===this)closeModal()"><div class="modal-center" style="width:min(94%,540px)">
    <div class="mhead"><h2>${mode==='edit'?'Edit User':'Add User'}</h2><button class="xclose" onclick="closeModal()" data-icon="close" data-size="20"></button></div>
    <div class="mbody"><div class="form-grid">
      <div class="field"><label>Full Name</label><input id="fName" value="${u.UserName||''}" placeholder="e.g. Praveen Kumar"></div>
      <div class="form-row2"><div class="field"><label>Mobile</label><input id="fMobile" value="${u.Mobile||''}" maxlength="10" ${mode==='edit'?'readonly':''} placeholder="10-digit number"></div>
        <div class="field"><label>Role</label><select class="inp" id="fRole">${roleOpts}</select></div></div>
      <div class="field"><label>Password</label><input id="fPass" type="password" placeholder="${mode==='edit'?'Leave blank to keep current':'Set a password'}"></div>
      <div><div class="perms-label">Permissions</div><div class="perms">
        <label class="toggle">Insert<span class="sw"><input type="checkbox" id="fIns" ${yn(u.DataInsert)?'checked':''}><span class="slide"></span></span></label>
        <label class="toggle">Update<span class="sw"><input type="checkbox" id="fUpd" ${yn(u.DataUpdate)?'checked':''}><span class="slide"></span></span></label>
        <label class="toggle">Delete<span class="sw"><input type="checkbox" id="fDel" ${yn(u.DataDelete)?'checked':''}><span class="slide"></span></span></label></div></div>
      <div class="err" id="fErr"></div>
      <div class="modal-foot"><button class="btn-cancel" onclick="closeModal()">Cancel</button>
      <button class="btn-save" id="fSave" onclick="saveUser('${mode}',${i??-1})">${mode==='edit'?'Update User':'Save User'}</button></div>
    </div></div></div></div>`;
  ICONS.close='<path d="M18 6 6 18"/><path d="m6 6 12 12"/>';hydrateIcons(document.getElementById('modalRoot'));
}

export async function saveUser(mode,i){
  const v=id=>document.getElementById(id).value,ck=id=>document.getElementById(id).checked?1:0;
  const name=v('fName').trim(),mobile=v('fMobile').trim(),role=v('fRole'),pass=v('fPass'),err=document.getElementById('fErr');
  if(!name){err.textContent='Please enter the user\u2019s name.';return}
  if(!/^\d{10}$/.test(mobile)){err.textContent='Mobile number must be exactly 10 digits.';return}
  if(mode==='add'&&pass.length<4){err.textContent='Password must be at least 4 characters.';return}
  const payload={Mobile:mobile,Password:pass,Company:session.company,Typed:role,UserName:name,DataInsert:ck('fIns'),DataUpdate:ck('fUpd'),DataDelete:ck('fDel'),NoOfDays:(mode==='edit'?(usersCache[i].NoOfDays||30):30)};
  document.getElementById('fSave').textContent='Saving…';
  try{await apiPost('PostApi.php',{ID:session.IMIE,TableName:'Logins'},payload);}catch(e){/* offline */}
  closeModal();go('users');toast(mode==='edit'?'User updated':'User added');
}

export function confirmDeleteUser(i){
  const u=usersCache[i];
  document.getElementById('modalRoot').innerHTML=`
   <div class="modal-overlay" onclick="if(event.target===this)closeModal()"><div class="modal-center">
    <div class="mbody" style="padding:30px 26px"><div class="confirm-ic" data-icon="trash" data-size="24"></div>
      <div class="confirm-txt">Delete <b>${u.UserName||u.Mobile}</b>?<br>This action cannot be undone.</div>
      <div class="modal-foot" style="justify-content:center"><button class="btn-cancel" onclick="closeModal()">Cancel</button>
      <button class="btn-danger" onclick="deleteUser('${u.Mobile}')">Delete</button></div></div></div></div>`;
  hydrateIcons(document.getElementById('modalRoot'));
}

export async function deleteUser(mobile){
  try{await apiPut('DeleteApi.php',{ID:session.IMIE,TableName:'Logins'},{Mobile:mobile});}catch(e){/* offline */}
  closeModal();go('users');toast('User deleted');
}
